import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/DashboardLayout';

const Home = Loadable(lazy(() => import('pages/dashboard/home')));

const Store = Loadable(lazy(() => import('pages/dashboard/store/Store')));
const Supplier = Loadable(lazy(() => import('pages/dashboard/supplier/Supplier')));
const ProductSearch = Loadable(lazy(() => import('pages/dashboard/productSearch/ProductSearch')));
const AccountPayable = Loadable(lazy(() => import('pages/dashboard/accountPayable/AccountPayable')));
const AccountPayableSearch = Loadable(lazy(() => import('pages/dashboard/accountPayable/AccountPayableSearch')));
const Stock = Loadable(lazy(() => import('pages/dashboard/Stock')));
const User = Loadable(lazy(() => import('pages/dashboard/user/User')));
const Purchase = Loadable(lazy(() => import('pages/dashboard/purchase/Purchase')));
const Sales = Loadable(lazy(() => import('pages/dashboard/sales/Sales')));
const ProductTransfer = Loadable(lazy(() => import('pages/dashboard/productTransfer/ProductTransfer')));
const ProductTransferReports = Loadable(lazy(() => import('pages/dashboard/productTransfer/ProductTransferReports')));
const SyncProblems = Loadable(lazy(() => import('pages/dashboard/syncProblems/SyncProblems')));

const Help = Loadable(lazy(() => import('pages/dashboard/Help')));
const Error404 = Loadable(lazy(() => import('pages/dashboard/Error404')));

const DashboardRoutes = (credentials) => {
    const dashboard_children = [
        {
            path: 'default',
            element: <Home />
        },
        {
            path: 'stock',
            element: <Stock />,
            secure: true
        },
        {
            path: 'users',
            element: <User />,
            secure: true
        },
        {
            path: 'users/:id',
            element: <User mode="update" />,
            secure: true
        },
        {
            path: 'users/:id/permissions',
            element: <User mode="permissions" />,
            secure: true
        },
        {
            path: 'users/create',
            element: <User mode="add" />,
            secure: true
        },
        {
            path: 'stores',
            element: <Store />
        },
        {
            path: 'stores/:id',
            element: <Store mode="update" />,
            secure: true
        },
        {
            path: 'stores/create',
            element: <Store mode="add" />,
            secure: true
        },
        {
            path: 'suppliers',
            element: <Supplier />
        },
        {
            path: 'suppliers/:id',
            element: <Supplier mode="update" />,
            secure: true
        },
        {
            path: 'suppliers/create',
            element: <Supplier mode="add" />,
            secure: true
        },
        {
            path: 'product-search',
            element: <ProductSearch />
        },
        {
            path: 'account-payable',
            element: <AccountPayable />
        },
        {
            path: 'account-payable/search',
            element: <AccountPayableSearch />
        },
        {
            path: 'purchases',
            element: <Purchase mode="list" />
        },
        {
            path: 'sales',
            element: <Sales />
        },
        {
            path: 'purchases/:id',
            element: <Purchase mode="update" />,
            secure: true
        },
        {
            path: 'purchases/:id/details',
            element: <Purchase mode="details" />,
            secure: true
        },
        {
            path: 'purchases/create',
            element: <Purchase mode="add" />,
            secure: true
        },
        {
            path: 'product-transfer',
            element: <ProductTransfer />,
            secure: true
        },
        {
            path: 'product-transfer/report',
            element: <ProductTransferReports />,
            secure: true
        },
        {
            path: 'sync-problems',
            element: <SyncProblems />
        }
    ];

    const children = dashboard_children.filter((children) => {
        if (children.secure && !credentials?.route_permissions[`dashboard/${children.path}`]) {
            return false;
        }
        return true;
    });

    return {
        path: '/',
        element: <DashboardLayout />,
        children: [
            {
                path: 'dashboard',
                children: children
            },
            {
                path: 'help',
                element: <Help />
            },
            {
                path: '*',
                element: <Error404 />
            }
        ]
    };
};

export default DashboardRoutes;
